export default __webpack_public_path__ + "static/media/tool-icon-goal-bottom.58c605a5.svg";